import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import Iconify from "../iconify";

export default function TopPurchaseUsersTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.users?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.store === 0 ? (
                  <AppleIcon />
                ) : (
                  <Iconify icon={"eva:google-outline"} />
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.userId}
              </TableCell>
              <TableCell component="th" scope="row">
                <a href={`/dashboard/profile?user_id=${row.userId}`}>
                  {row.username}
                </a>
              </TableCell>
              <TableCell component="th" scope="row">
                {row.totalPrice / 100} {"$"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
